@use 'sass:map';
@use '../../variables' as *;
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

@keyframes search-slide-down {
  from {
    transform: translateY(0);
  }

  15% {
    z-index: -1;
    opacity: 0;
  }

  to {
    z-index: unset;
    transform: translateY($header-height);
    opacity: 1;
  }
}

.principal-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 16px;
  margin-left: $drawer-width;
  height: $header-height;
  padding: 16px;

  &.not-logged {
    margin-left: unset;

    > .start {
      width: unset;

      > svg {
        flex: 0 1 auto;

        &.simple {
          color: var(--#{$prefix}primary);
          height: 36px;
          width: 36px;
        }
      }
    }

    > .end > a {
      flex: 0 0 auto;
      @include button-and-tag;
      font-family: $sora;
      padding: 6px 12px;
      font-weight: 600;
      font-size: var(--#{$prefix}font-size-md);

      &:focus-visible {
        outline: 4px solid var(--#{$prefix}primary);
      }
    }
  }

  > .start {
    display: flex;
    column-gap: 16px;
    align-items: center;
    width: $drawer-expended-width - $drawer-width - 2 * 16;

    &:has(> .dropdown-info) {
      width: $drawer-expended-width - $drawer-width - 16 + 44;
    }

    > span {
      flex: 0 1 auto;
      font-family: $sora;
      font-size: var(--#{$prefix}font-size-sm);
      font-weight: 600;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-wrap-style: balance;
      overflow: hidden;
    }

    > .tooltip-container:has(> button#info-etab) {
      display: none;

      > button#info-etab {
        flex-shrink: 0;

        &:hover,
        &:focus-visible {
          ~ .tooltip {
            display: unset;
          }
        }
      }
    }

    > .dropdown-info {
      display: none;
    }
  }

  > .middle {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
    visibility: hidden;
    transition:
      margin-left 0.15s cubic-bezier(0.4, 0, 0.2, 1),
      transform 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    &.visible {
      visibility: visible;
      animation: search-slide-down 0.15s cubic-bezier(0.4, 0, 0.2, 1) forwards;
    }

    &.searching {
      z-index: 4 !important;
    }
  }

  > .end {
    display: flex;
    align-items: center;
    column-gap: 16px;

    > .search,
    > .notification {
      position: relative;
    }

    > .notification {
      display: none;
    }
  }

  @media (width >= map.get($custom-breakpoints, user-info)) {
    > .start > .tooltip-container:has(> button#info-etab) {
      display: inline;
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) and (height >= map.get($grid-breakpoints, md)) {
    > .start {
      > .tooltip-container:has(> button#info-etab) {
        display: none;
      }

      > .dropdown-info {
        display: unset;
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    > .middle.navigation-drawer-visible {
      margin-left: $drawer-width;
    }

    > .end > .notification {
      display: unset;
    }
  }

  @media (width >= map.get($grid-breakpoints, lg)) {
    > .start {
      flex-shrink: 0;
    }

    > .middle {
      flex: 1 1 auto;
      position: unset;
      opacity: 1 !important;
      z-index: unset !important;
      transform: translateY(0) !important;
      margin: 0 !important;
      visibility: visible;

      &.visible {
        animation: search-slide-down 0.15s cubic-bezier(0.4, 0, 0.2, 1) backwards;
      }
    }

    > .end > .search {
      display: none;
    }
  }
}
